import moment from 'moment'
import React, {useEffect, useMemo, useState} from 'react'
import {useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import RestPasswordPopup from '../../../../Components/RestPasswordPopup'
import CreateUserAccountPopup from '../Modal/CreateUserAccountPopup'

const UserProfile = () => {
  const param: any = useLocation()
  const [passwordPopup, setPasswordPopup] = useState(false)

  const location = useLocation()
  const {userProp} = location.state || ({} as any)

  // const [data, setData] = useState<any>({})
  const userData = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)
  const data = userProp?.user ? userProp.user : userData

  const UserParent = useSelector((state: any) => state?.ProfileData?.ProfileData?.parent)
  const parent = userProp?.parent ? userProp.parent : UserParent
  
  const [updateOwnerProfile, setUpdateOwnerProfile] = useState(false)

  const OwnerForm = useMemo(
    () => (
      <CreateUserAccountPopup
        data={data}
        show={updateOwnerProfile}
        handleClose={() => setUpdateOwnerProfile(false)}
      />
    ),
    [updateOwnerProfile, data]
  )

  const RoleName: any = {
    FEuserAdmin: 'User Admin',
    FEmanager: 'Manager',
    FEauthor: 'Author',
    FEviewer: 'Viewer',
    owner: 'Owner',
    subAccount: 'Sub Account',
    FEstaff: 'Staff Member'
  }

  const StaffAccountDetails = [
    {lable: 'Email', value: data?.email},
    {lable: 'Phone', value: data?.mobile},
  ]

  const UserAccountDetails = [
    {lable: 'Business name', value: data?.companyName},
    {lable: 'Email', value: data?.email},
    {lable: 'Phone', value: data?.mobile},
    {lable: 'Industry', value: data?.industry},
    {lable: 'Company', value: data?.companyName},
    {lable: 'Company Size', value: data?.companySize},
    {lable: 'Website', value: data?.companyWebsite},
    {lable: 'Source', value: data?.source},
    {lable: 'Cellcast birthday', value: moment(data?.createdAt).format('DD/MM/YYYY')},
  ]

  const handleEdit = () => {
    setUpdateOwnerProfile(true)
  }

  return (
    <>
      {OwnerForm}
      <RestPasswordPopup
        show={passwordPopup}
        handleClose={() => setPasswordPopup(false)}
        data={data}
      />
      <div className='col-md-4'>
        <div className='card mb-6'>
          <div className='card-body pt-9 pb-0'>
            <div className='d-flex flex-wrap flex-sm-nowrap flex-column align-items-center'>
              <div className='mb-4'>
                <div className='symbol symbol-100px symbol-fixed position-relative'>
                  {data?.avatar && data?.avatar !== 'undefined' ? (
                    <img className='rounded-circle' src={data?.avatar} alt='' />
                  ) : (
                    <span className='circle1'>{`${
                      data?.firstName !== undefined && data?.firstName !== ''
                        ? data?.firstName?.split('')[0]?.toUpperCase()
                        : ''
                    }${
                      data?.lastName !== undefined && data?.lastName !== ''
                        ? data?.lastName?.split('')[0]?.toUpperCase()
                        : ''
                    }`}</span>
                  )}
                  <div
                    className={`position-absolute translate-middle bottom-0 start-100 mb-6 rounded-circle border border-4 border-white h-20px w-20px ${
                      data?.status2 == 'active'
                        ? ' bg-success '
                        : data?.status2 == 'inactive'
                        ? 'bg-secondary'
                        : 'bg-danger'
                    }`}
                  ></div>
                </div>
              </div>
              <div className='flex-grow-1'>
                <div className='d-flex justify-content-between align-items-start flex-wrap mb-2 justify-content-center'>
                  <div className='d-flex flex-column align-items-center w-100'>
                    <div className='d-flex align-items-center'>
                      <span className='text-gray-900 text-hover-primary fs-2 fw-bolder me-1'>
                        {data?.name}
                      </span>
                    </div>
                    {parent && parent != null && (
                      <div className='d-flex align-items-center mb-3'>
                        <span className='text-muted fw-bold text-muted d-block fs-7'>
                          child user from {parent.name}
                        </span>
                      </div>
                    )}
                    <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2 justify-content-center '>
                      <span className='d-flex align-items-center mb-2 btn-light-primary btn btn-sm fs-6 py-2'>
                        {RoleName?.[data?.role]}
                      </span>
                    </div>
                    <div className='d-flex flex-wrap fw-bold fs-6 mb-0 pe-2 justify-content-center '>
                      <a href='#' className='d-flex align-items-center text-dark fs-2 fs-6 py-2'>
                        Support Tickets
                        <span className='svg-icon svg-icon-primary svg-icon-2x ms-3'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            xmlnsXlink='http://www.w3.org/1999/xlink'
                            width='24px'
                            height='24px'
                            viewBox='0 0 24 24'
                            version='1.1'
                          >
                            <g stroke='none' strokeWidth={1} fill='none' fillRule='evenodd'>
                              <rect x={0} y={0} width={24} height={24} />
                              <circle fill='#000000' opacity='0.3' cx={12} cy={12} r={10} />
                              <rect fill='#ffffff' x={11} y={7} width={2} height={8} rx={1} />
                              <rect fill='#ffffff' x={11} y={16} width={2} height={2} rx={1} />
                            </g>
                          </svg>
                        </span>
                      </a>
                    </div>

                    {data?.smsStatus === 'approved' && (
                      <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2 justify-content-center '>
                        <KTSVG
                          path='/media/icons/duotune/general/gen026.svg'
                          className='svg-icon-2 ms-1'
                        />{' '}
                        Verified
                      </div>
                    )}

                    {data?.smsStatus === 'newUser' && (
                      <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2 justify-content-center '>
                        <KTSVG
                          path='/media/icons/duotune/general/gen026.svg'
                          className='svg-icon-2 ms-1 svg-icon-success'
                        />{' '}
                        UnVerified
                      </div>
                    )}

                    <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2 justify-content-center flex-wrap '>
                      {data?.tags?.map(
                        (tag: {_id: string; name: string; color: string}, i: number) => (
                          <div key={i} className='badge blue_text_badge badge-square me-2 p-2 mb-2'>
                            {tag?.name}
                          </div>
                        )
                      )}
                    </div>

                    <div className='row w-100 mb-4'>
                      <div
                        className='md-12'
                        style={{
                          borderTop: '1px dashed #e4e6ef',
                        }}
                      ></div>
                    </div>

                    <div className='d-flex flex-column flex-grow-1 fw-bold fs-6 mb-2 pe-2 justify-content-center align-items-center'>
                      <h4>Account Manager</h4>
                      <p className='text-muted'>
                        {data?.accountManager ? data?.accountManager?.name : '-'}
                      </p>
                    </div>
                    <div className='d-flex flex-column flex-grow-1 fw-bold fs-6 mb-4 pe-2 justify-content-center align-items-center'>
                      <h4>Sales</h4>
                      <p className='text-muted'>{data?.sales ? data?.sales?.name : '-'}</p>
                    </div>
                  </div>
                </div>
                <div className='d-flex flex-wrap flex-stack'>
                  <div className='d-flex flex-column flex-grow-1'>
                    <div className='d-flex flex-wrap'>
                      <div className='border border-gray-300 border-dashed rounded py-3 px-4 me-4 mb-3 min-w-25'>
                        <div className='d-flex align-items-center'>
                          <div
                            className='fs-2 fw-bolder me-2 text-gray-600'
                            data-kt-countup='true'
                            data-kt-countup-value={47}
                          >
                            0
                          </div>
                          <span className='svg-icon svg-icon-3 svg-icon-success me-2'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width={24}
                              height={24}
                              viewBox='0 0 24 24'
                              fill='none'
                            >
                              <rect
                                opacity='0.5'
                                x={13}
                                y={6}
                                width={13}
                                height={2}
                                rx={1}
                                transform='rotate(90 13 6)'
                                fill='currentColor'
                              />
                              <path
                                d='M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z'
                                fill='currentColor'
                              />
                            </svg>
                          </span>
                        </div>
                        <div className='fw-bold fs-6 text-gray-400'>Total</div>
                      </div>
                      <div className='border border-gray-300 border-dashed rounded  py-3 px-4 me-4 mb-3 min-w-25'>
                        <div className='d-flex align-items-center'>
                          <div
                            className='fs-2 fw-bolder me-2 text-gray-600'
                            data-kt-countup='true'
                            data-kt-countup-value={34}
                          >
                            0
                          </div>
                          <span className='svg-icon svg-icon-3 svg-icon-success me-2'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width={24}
                              height={24}
                              viewBox='0 0 24 24'
                              fill='none'
                            >
                              <rect
                                opacity='0.5'
                                x={13}
                                y={6}
                                width={13}
                                height={2}
                                rx={1}
                                transform='rotate(90 13 6)'
                                fill='currentColor'
                              />
                              <path
                                d='M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z'
                                fill='currentColor'
                              />
                            </svg>
                          </span>
                        </div>
                        <div className='fw-bold fs-6 text-gray-400'>Solved</div>
                      </div>
                      <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 min-w-25'>
                        <div className='d-flex align-items-center'>
                          <div
                            className='fs-2 fw-bolder me-2 text-gray-600'
                            data-kt-countup='true'
                            data-kt-countup-value={13}
                          >
                            0
                          </div>
                          <span className='svg-icon svg-icon-3 svg-icon-danger me-2'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width={24}
                              height={24}
                              viewBox='0 0 24 24'
                              fill='none'
                            >
                              <rect
                                opacity='0.5'
                                x={11}
                                y={18}
                                width={13}
                                height={2}
                                rx={1}
                                transform='rotate(-90 11 18)'
                                fill='currentColor'
                              />
                              <path
                                d='M11.4343 15.4343L7.25 11.25C6.83579 10.8358 6.16421 10.8358 5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75L11.2929 18.2929C11.6834 18.6834 12.3166 18.6834 12.7071 18.2929L18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25C17.8358 10.8358 17.1642 10.8358 16.75 11.25L12.5657 15.4343C12.2533 15.7467 11.7467 15.7467 11.4343 15.4343Z'
                                fill='currentColor'
                              />
                            </svg>
                          </span>
                        </div>
                        <div className='fw-bold fs-6 text-gray-400'>Open</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='d-flex mb-2'>
              <div className='accordion w-100' id='kt_accordion_1'>
                <div className='accordion-item border-0'>
                  <h2
                    className='accordion-header align-items-baseline gap-19 border-bottom pb-3 d-flex'
                    id='kt_accordion_1_header_1'
                  >
                    <button
                      className='accordion-button bg-transparent fs-4 fw-bolder collapsed py-3 px-4 mt-4'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#kt_accordion_1_body_1'
                      aria-expanded='false'
                      aria-controls='kt_accordion_1_body_1'
                    >
                      <span className='d-inline-flex me-4'>Account Details</span>
                    </button>
                    <button
                      onClick={handleEdit}
                      className='btn btn-light-primary btn-sm me-2'
                      id='kt_user_follow_button'
                    >
                      <span className='svg-icon svg-icon-3 d-none'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width={24}
                          height={24}
                          viewBox='0 0 24 24'
                          fill='none'
                        >
                          <path
                            opacity='0.3'
                            d='M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z'
                            fill='currentColor'
                          />
                          <path
                            d='M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z'
                            fill='currentColor'
                          />
                        </svg>
                      </span>
                      <span className='indicator-label'>Edit</span>
                    </button>
                  </h2>
                  <div
                    id='kt_accordion_1_body_1'
                    className='accordion-collapse collapse'
                    aria-labelledby='kt_accordion_1_header_1'
                    data-bs-parent='#kt_accordion_1'
                  >
                    <div className='accordion-body px-0'>
                      <div className='card-body p-0'>
                        {/* <span className='badge badge-light-info mb-5'>Golden user</span> */}
                        {(data?.role === 'owner' ? UserAccountDetails : StaffAccountDetails)?.map(
                          (data: any, id: number) => (
                            <div key={id} className='row mb-7'>
                              <label className='col-lg-12 fw-bolder text-gray-800'>
                                {data?.lable}
                              </label>
                              <div className='col-lg-12'>
                                <span className='fw-semibold fs-6 text-muted'>{data?.value}</span>
                              </div>
                            </div>
                          )
                        )}

                        <div className='row mb-7'>
                          <label className='col-lg-12 fw-bolder text-gray-800'>Password</label>
                          <div className='col-lg-6 pt-1'>
                            <span className='fw-semibold fs-6 text-muted'>*************</span>
                          </div>
                          <div className='col-lg-6'>
                            <button
                              onClick={() => setPasswordPopup(true)}
                              className='btn p-0 link-primary'
                            >
                              {' '}
                              Change Password
                            </button>
                          </div>
                        </div>

                        {/* <div className='row'>
                          <label className='col-lg-12 fw-bolder text-gray-800'>Note</label>
                          <div className='col-lg-12'>
                            <span className='fw-semibold fs-6 text-muted'>
                              Here are same notes on this client
                            </span>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {param?.state?.[1] == 'user' && (
          <div className='card card-xl-stretch mb-5 mb-xl-8'>
            <div className='card-header border-0 pt-5'>
              <div className='card-title d-flex align-items-center'>
                <h3 className='fw-bolder m-0 text-gray-800'>Integrations</h3>
              </div>
            </div>
            <div className='card-body pt-5'>
              <div className='d-flex align-items-sm-center border-bottom-dotted border-2 border-gray-300 pb-5 mb-5'>
                <div className='symbol symbol-50px me-5'>
                  <span className='symbol-label'>
                    <img
                      src='assets/media/svg/brand-logos/plurk.svg'
                      className='h-50 align-self-center'
                      alt=''
                    />
                  </span>
                </div>
                <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
                  <div className='flex-grow-1 me-2'>
                    <a href='#' className='text-gray-800 text-hover-primary fs-6 fw-bolder'>
                      Google
                    </a>
                    <span className='text-muted fw-bold d-block fs-7'>Get more reviews</span>
                  </div>
                  <button
                    className='btn btn-icon btn-active-light-primary w-30px h-30px me-3'
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_update_permission'
                  >
                    <span className='svg-icon svg-icon-3 svg-icon-2tx'>
                      <svg
                        width={24}
                        height={24}
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z'
                          fill='currentColor'
                        />
                        <path
                          opacity='0.3'
                          d='M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z'
                          fill='currentColor'
                        />
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
              <div className='d-flex align-items-sm-center border-bottom-dotted border-2 border-gray-300 pb-5 mb-5'>
                <div className='symbol symbol-50px me-5'>
                  <span className='symbol-label'>
                    <img
                      src='assets/media/svg/brand-logos/telegram.svg'
                      className='h-50 align-self-center'
                      alt=''
                    />
                  </span>
                </div>
                <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
                  <div className='flex-grow-1 me-2'>
                    <a href='#' className='text-gray-800 text-hover-primary fs-6 fw-bolder'>
                      Shopify
                    </a>
                    <span className='text-muted fw-bold d-block fs-7'>e-commerce</span>
                  </div>
                  <button
                    className='btn btn-icon btn-active-light-primary w-30px h-30px me-3'
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_update_permission'
                  >
                    <span className='svg-icon svg-icon-3 svg-icon-2tx'>
                      <svg
                        width={24}
                        height={24}
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z'
                          fill='currentColor'
                        />
                        <path
                          opacity='0.3'
                          d='M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z'
                          fill='currentColor'
                        />
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
              <div className='d-flex align-items-sm-center border-bottom-dotted border-2 border-gray-300 pb-5 mb-5'>
                <div className='symbol symbol-50px me-5'>
                  <span className='symbol-label'>
                    <img
                      src='assets/media/svg/brand-logos/vimeo.svg'
                      className='h-50 align-self-center'
                      alt=''
                    />
                  </span>
                </div>
                <div className='d-flex align-items-center flex-row-fluid flex-wrap'>
                  <div className='flex-grow-1 me-2'>
                    <a href='#' className='text-gray-800 text-hover-primary fs-6 fw-bolder'>
                      zapier
                    </a>
                    <span className='text-muted fw-bold d-block fs-7'>e-commerce</span>
                  </div>
                  <button
                    className='btn btn-icon btn-active-light-primary w-30px h-30px me-3'
                    data-bs-toggle='modal'
                    data-bs-target='#kt_modal_update_permission'
                  >
                    <span className='svg-icon svg-icon-3 svg-icon-2tx'>
                      <svg
                        width={24}
                        height={24}
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z'
                          fill='currentColor'
                        />
                        <path
                          opacity='0.3'
                          d='M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z'
                          fill='currentColor'
                        />
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
              <div className='d-flex align-items-sm-center justify-content-center'>
                <div className='d-flex my-4'>
                  <a href='#' className='btn btn-light-primary' id='kt_user_follow_button'>
                    <span className='svg-icon svg-icon-3 d-none'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width={24}
                        height={24}
                        viewBox='0 0 24 24'
                        fill='none'
                      >
                        <path
                          opacity='0.3'
                          d='M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z'
                          fill='currentColor'
                        />
                        <path
                          d='M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z'
                          fill='currentColor'
                        />
                      </svg>
                    </span>
                    <span className='indicator-label'>Add new integration</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default UserProfile
